import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IrbCommonModule } from "@irb-common/irb-common.module";
import { CreatePortfolioDialogComponent } from "./create-portfolio-dialog/create-portfolio-dialog.component";
import { PortfolioAccountAssignmentDialogComponent } from "./portfolio-account-assignment-dialog/portfolio-account-assignment-dialog.component";
import { PortfolioImportHoldingsDialogComponent } from "./portfolio-import-holdings-dialog/portfolio-import-holdings-dialog.component";
import { PortfolioCreatedDialogComponent } from "./portfolio-created-dialog/portfolio-created-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IrbCommonModule
  ],
  declarations: [
    CreatePortfolioDialogComponent, 
    PortfolioAccountAssignmentDialogComponent, 
    PortfolioImportHoldingsDialogComponent, PortfolioCreatedDialogComponent
  ]
})
export class IrbCreatePortfolioModule { }
